import {Component, OnInit} from '@angular/core';
import {TableModule, TableRowCollapseEvent, TableRowExpandEvent} from "primeng/table";
import {Button} from "primeng/button";
import {MessageService} from "primeng/api";
import {SipoService} from "../../services/SipoService";
import {NgForOf, NgIf} from "@angular/common";
import {RatingModule} from "primeng/rating";
import {TagModule} from "primeng/tag";
import {FormsModule} from "@angular/forms";
import {DateTimePipe} from "../../../shared/pipes/DateTimePipe";
import {SignedFileNamePipe} from "../../../shared/pipes/signed-file-name.pipe";
import {TranslatePipe, TranslateService} from "@ngx-translate/core";
import {EvidenceSvgPipe} from "../../../shared/pipes/evidence-svg.pipe";
import {TriggerEventCommunicationService} from "../../services/trigger-event-communication.service";
import {Subscription} from "rxjs";
import {ProgressSpinnerModule} from "primeng/progressspinner";
import {SkeletonModule} from "primeng/skeleton";
import {SignTaskDetailsComponent} from "../../../shared/components/sign-task-details/sign-task-details.component";
import {log} from "@angular-devkit/build-angular/src/builders/ssr-dev-server";
import {
    TemporarySignTaskDetailsComponent
} from "../../../shared/components/temporary-sign-task-details/temporary-sign-task-details.component";
import {SignComponent} from "../../sign/sign.component";
import {DialogService, DynamicDialogRef} from "primeng/dynamicdialog";
import {SignProcessEditingService} from "../../services/sign-process-editing.service";
import {Ripple} from "primeng/ripple";
import {
    CancelSignConfirmationModalComponent
} from "../../sign/cancel-sign-confirmation-modal/cancel-sign-confirmation-modal.component";
import {DeleteSignConfirmComponent} from "../../sign/delete-confirm-modal/delete-sign-confirm.component";
import {SignatureLevel} from "../../model/signer-model";
import {SubscriptionsService} from "../../services/subscriptions.service";
import { timer } from 'rxjs';

@Component({
    selector: 'app-right-content',
    standalone: true,
    imports: [
        TableModule,
        Button,
        RatingModule,
        TagModule,
        FormsModule,
        DateTimePipe,
        NgIf,
        SignedFileNamePipe,
        TranslatePipe,
        EvidenceSvgPipe,
        ProgressSpinnerModule,
        SkeletonModule,
        TemporarySignTaskDetailsComponent,
        Ripple
    ],
    providers: [
        MessageService
    ],
    templateUrl: './right-content.component.html',
    styleUrl: './right-content.component.scss'
})
export class RightContentComponent implements OnInit {
    signingProcessList!: any[];

    expandedRows = {};
    eventTriggerSubscription!: Subscription;
    ref!: DynamicDialogRef;

    constructor(private sipoService: SipoService,
                private messageService: MessageService,
                private triggerEventService: TriggerEventCommunicationService,
                private translateService: TranslateService,
                private dialogService: DialogService,
                private signProcessEditingService: SignProcessEditingService,
                private translate: TranslateService,
                private subscriptionsService: SubscriptionsService) {
    }

    ngOnInit() {

        this.getData();
        this.sipoService.reloadData.subscribe(value => {

            timer(1500).subscribe(() => {
                this.getData();
            });

        });

        this.updateData();
    }

    updateData() {
        this.eventTriggerSubscription = this.triggerEventService.eventTriggerObservable.subscribe(event => {
            this.getData()
        })
    }

    openSignDialogForEditing(processId: string): void {

        console.log(processId)

        // ToDo: Buna neden ihtiyac duyuyoruz?
        this.signProcessEditingService.updateProcessId(processId);

        this.ref = this.dialogService.open(SignComponent, {
            header: this.translate.instant('sipo.sign'),
            height: 'fit-content',
            width: '105rem',
            //height: '30rem',
            maximizable: true,
            closable: false,
            showHeader: true,
            data: {
                editingProcessId: processId
            }
        });
    }

    getData() {
        this.sipoService.getSigningProcessList().subscribe({
            next: data => {

                // In here we are filtering the undone processes.
                // In future when it is able to continue them this method will be cleared and
                // the data will be declared to the signingProcessList
                this.signingProcessList = data.filter((item: any) => item.fileName && item.signType);
            },
            error: err => {
                console.error(err);
            }
        })
    }

    isDetailsOpen: boolean = false;

    detailsPageProcessId!: string;

    getDetails(processId: string) {

        const detailsEl = document.getElementById('detailsPage');
        detailsEl?.classList.remove('translate-x-100');
        this.detailsPageProcessId = processId;

        this.isDetailsOpen = true;
    }

    receiveDetailsPageClose(event: boolean) {
        this.isDetailsOpen = event
    }

    isProductSubItemsLoading: boolean = false;

    onRowExpand(event: TableRowExpandEvent) {

        this.isProductSubItemsLoading = true;

        this.sipoService.getSubItemsList(event.data.id).subscribe({
            next: sub => {
                event.data.subItems = sub;
                this.isProductSubItemsLoading = false;
            },
            error: err => {
                console.log(err);
            }
        });
    }

    expandAll() {
        this.expandedRows = this.signingProcessList.reduce((acc, p) => (acc[p.id] = true) && acc, {});
    }

    collapseAll() {
        this.expandedRows = {};
    }

    getStatus(status: string) {
        switch (status) {
            case 'created':
            case 'started':
                return 'warning';
            case 'signed':
            case 'finished':
                return 'success';
                return 'danger';
            default:
                return 'info';
        }
    }


    getStatusText(status: string) {
        let returnValue;
        switch (status) {
            case 'created':
            case 'started':
                this.translateService.get('sipo.status-started').subscribe(val => returnValue = val);
                return returnValue
            case 'signed':
            case 'finished':
                this.translateService.get('sipo.status-finished').subscribe(val => returnValue = val);
                return returnValue
            case 'draft':
                this.translateService.get('sipo.status-draft').subscribe(val => returnValue = val);
                return returnValue
            // return 'fällig';
            default:
                this.translateService.get('sipo.status-open').subscribe(val => returnValue = val);
                return returnValue
        }
    }

    getStatusSeverity(status: string) {
        switch (status) {
            case 'PENDING':
                return 'warning';
            case 'DELIVERED':
                return 'success';
            case 'CANCELLED':
                return 'danger';
        }
        return 'info';
    }


    onRowCollapse(event: TableRowCollapseEvent) {
        this.messageService.add({
            severity: 'success',
            summary: 'Product Collapsed',
            detail: event.data.name,
            life: 3000
        });
    }

    downloadFile(fileId: string, fileType: string, filename: string) {
        this.sipoService.getFile(fileId, fileType).subscribe({
            next: (base64: string) => {
                this.handleFileDownload(base64, fileType, filename);
            },
            error: err => {
                console.error('Fehler beim Laden der Datei:', err);
            }
        });
    }


    downloadWorkflowFile(fileId: string, fileType: string, filename: string) {
        this.sipoService.getSubitemFile(fileId, fileType).subscribe({
            next: (base64: string) => {
                this.handleFileDownload(base64, fileType, filename);
            },
            error: err => {
                console.error('Fehler beim Laden der Datei:', err);
            }
        });
    }

    handleFileDownload(base64: string, fileType: string, filename: string) {
        const byteCharacters = atob(base64);
        const byteNumbers = Array.from(byteCharacters).map(ch => ch.charCodeAt(0));
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], {type: 'application/pdf'});
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename ? filename : fileType + '-document.pdf';
        link.click();
        URL.revokeObjectURL(url);
    }

    ngOnDestroy(): void {
        this.eventTriggerSubscription.unsubscribe();
    }


    deleteItem(processId: string, signType: string) {


        this.ref = this.dialogService.open(DeleteSignConfirmComponent, {
            width: '45rem',
            data: {processId: processId}
        });

        this.ref.onClose.subscribe(value => {
            if (value) {
                console.log(value);

                this.sipoService.deleteProcess(processId).subscribe({
                    next: value1 => {

                        this.getData();
                        const paymentCert = [SignatureLevel.MAX, SignatureLevel.HIGH].includes(signType as SignatureLevel);
                        if (paymentCert) {
                            this.subscriptionsService.refreshCreditValue.next(new Date());
                        }
                    },
                    error: err => {

                    }
                });
            }
        });


    }
}
